import React, { useEffect, useState } from 'react'
import { Doc } from "@/services/model/docs"
import { Translates } from '@/services/repository/i18n'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'
import './qrcode.css'



export function MachinePopupQRCodeBody({ services, session, translates, machineId, title }: { translates: Translates, services: Services, machineId: string | undefined, session: CurrentSession | undefined, title: string }) {
    const [qrId, setQRId] = useState<string>()

    useEffect(() => {
        if (machineId === undefined) {
            setQRId(undefined)
            return
        }
        fetch(`/api/communal/qr/formachine/${machineId}/first`).then((response) => { 
            return response.json()
        }).then((qrId: string) => {
            setQRId(qrId)
        })
    }, [machineId])

    const renderQR = (qid: string) => <>
        <div className='img-wrap'>
            <img className='qrimage' src={'/api/communal/qr/img/' + qid} />
        </div>
        <a className='main-btn' href={'/api/communal/qr/img/' + qid} download={true}>
            {translates.for('popup.machine_qrcode.download')}
        </a>
    </>

    return <div className='qrcode-popup-body'>
        <h3>{title ? title + '-' : null}{translates.for('popup.machine_qrcode.qr_section_title')}</h3>
        {qrId ? renderQR(qrId) : null}
    </div>
}